import { useState } from 'react';
import './by-laws.scss';
import bylawsData from './by-laws.json';

const ByLaws = () => {
  const [expandedArticles, setExpandedArticles] = useState(
    bylawsData.articles.map((_, index) => index === 0)
  );

  const toggleArticle = (index) => {
    setExpandedArticles((current) =>
      current.map((isOpen, itemIndex) =>
        itemIndex === index ? !isOpen : isOpen
      )
    );
  };

  const renderSectionContent = (
    content,
    marker?,
    contentClassName = 'bylaws-details__content',
    subtitle?
  ) =>
    content.split('\n\n').map((paragraph, index) => (
      <div key={index} className="bylaws-details__content-row">
        <span className="bylaws-details__section-marker">
          {index === 0 ? marker : ''}
        </span>
        <p className={contentClassName}>
          {index === 0 && subtitle && (
            <strong className="bylaws-details__subtitle">{subtitle}: </strong>
          )}
          {paragraph}
        </p>
      </div>
    ));

  return (
    <div className="bylaws-page">
      <section className="bylaws-hero">
        <div className="bylaws-hero__overlay" />
        <div className="bylaws-hero__content">
          <h1>By-Laws</h1>
          <p>
            The Missouri Self-Insurers Association's by-laws govern the operation
            and management of the organization.
          </p>
        </div>
      </section>

      <section className="bylaws-details">
        <div className="bylaws-details__inner">
          <p className="bylaws-details__intro">{bylawsData.documentTitle}</p>

          <div className="bylaws-details__articles">
            {bylawsData.articles.map((article, articleIndex) => {
              const isOpen = expandedArticles[articleIndex];

              return (
                <article
                  key={articleIndex}
                  className={`bylaws-details__article ${isOpen ? 'is-open' : ''}`}
                >
                  <button
                    type="button"
                    className="bylaws-details__article-toggle"
                    onClick={() => toggleArticle(articleIndex)}
                    aria-expanded={isOpen}
                  >
                    <div className="bylaws-details__article-heading">
                      <h2 className="bylaws-details__article-title">{article.title}</h2>
                      <span className="bylaws-details__article-indicator">
                        {isOpen ? '−' : '+'}
                      </span>
                    </div>
                  </button>

                  {isOpen && (
                    <div className="bylaws-details__article-body">
                      {article.sections.map((section, sectionIndex) => (
                        <div key={sectionIndex} className="bylaws-details__section">
                          <div className="bylaws-details__section-body">
                            {renderSectionContent(
                              section.content,
                              section.title,
                              'bylaws-details__content',
                              section.subtitle
                            )}

                            {section.subsections?.length > 0 && (
                              <div className="bylaws-details__subsections">
                                {section.subsections.map((subsection, subIndex) => (
                                  <div key={subIndex} className="bylaws-details__subsection">
                                    {renderSectionContent(
                                      subsection.content,
                                      subsection.title,
                                      'bylaws-details__subsection-content',
                                      subsection.subtitle
                                    )}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </article>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ByLaws;
